// /**
//  * Partner - Add
//  */

// React
import React, {useEffect, useRef, useState} from 'react';

// react hook form
import {Controller, useForm} from 'react-hook-form';

// Client SDK
import Client from 'client-sdk/src/client';
import {GetAllUsersRequestBuilder} from 'client-sdk/src/users/users';
import CommonRepository from 'client-sdk/src/Repository/common-repository';
import PartnersRepository from 'client-sdk/src/Repository/partners-repository'
// UI
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';
import {
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
  Checkbox,
  FormHelperText,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccount,
  mdiAccountOutline,
  mdiPhoneOutline,
  mdiHomeOutline,
  mdiTextBoxSearchOutline,
  mdiClipboardAccountOutline,
  mdiAccountNetworkOutline,
  mdiAccountTieOutline,
  mdiCounter,
  mdiPostOutline,
} from '@mdi/js';

// helpers
import {flattenObject, removeEmptyValueObject} from '../../../utils/helpers';

// Type
import {Partner} from '../interfaces';
import {User} from '../../users/interfaces';
import handleError from '../../../utils/handleError';

type Props = {
  create: (body: Partner) => void;
  onClose: () => void;
};

type Inputs = {
  name: string;
  workField: string;
  phoneNumber: number;
  address: string;
  representative: string;
  representativePosition: string;
  ranking: string;
  marketer: string;
  zipCode: string;
  province: string;
  city: string;
  economicCode: string;
  companyName: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      // width: '25ch',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      // marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
    },
  })
);

export default function Add(props: Props) {
  const classes = useStyles();

  const {register, handleSubmit, watch, errors, getValues, setValue, control} = useForm<Inputs>();
  const password = useRef({});
  password.current = watch('password', '');

  const [adminId, setAdminId] = useState(0 as number);
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
  const [options, setOptions] = React.useState<User[]>([]);
  const [citiesList, setCitiesList] = useState([]);
  const [provincesList, setProvincesList] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const loading = openAutocomplete && options.length === 0;
  const [sendByCo, setSendByCo] = useState(false);

  React.useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    (async () => {
      const token = localStorage.getItem('token') || '';
      const makeRequest = new GetAllUsersRequestBuilder()
        .params({
          'role.equals': 'PARTNER_ADMIN',
          'partnersId.specified': false,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      const users = response.data as any;
      if (active) {
        setOptions(users as User[]);
      }
      if (users.length === 0) {
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    getProvinces();
    getProfiles();
  }, []);

  const getProfiles = async () => {
    try {
      const response = await PartnersRepository.getAllProfiles({})
      setProfiles(response.data)
    } catch (error) {
      console.log(error)
      handleError(error)
    }
  }

  React.useEffect(() => {
    if (!openAutocomplete) {
      setOptions([]);
    }
  }, [openAutocomplete]);

  const onSubmit = (data: any) => {
    const {
      name,
      workField,
      phoneNumber,
      address,
      representative,
      representativePosition,
      ranking,
      marketer,
      zipCode,
      province,
      city,
      economicCode,
      companyName,
      profile,
      sepidarCode,
      registrationCode
    } = data;

    props.create({
      name,
      workField: workField?.length > 0 ? workField : null,
      phoneNumber: phoneNumber.length > 0 ? phoneNumber : null,
      address,
      representative: representative.length > 0 ? representative : null,
      representativePosition:
        representativePosition.length > 0 ? representativePosition : null,
      ranking: ranking.length > 0 ? ranking : null,
      marketer: marketer.length > 0 ? marketer : null,
      adminId,
      zipCode,
      province,
      profileId: profile,
      sepidarCode: sepidarCode ? sepidarCode : null,
      registrationCode: registrationCode ? registrationCode : null,
      city,
      economicCode,
      companyName,
      isUsingPartnerAddress: sendByCo,
      status: 'ACTIVE',
      type: 'MANUAL',
    });
  };

  const getCities = async (provinceId: number) => {
    try {
      const response = await CommonRepository.getCities({
        payload: {'provinceId.equals': provinceId},
      });
      setCitiesList(response.data);
    } catch (err) {
      handleError(err);
    }
  };

  const getProvinces = async () => {
    try {
      const response = await CommonRepository.getProvinces({payload: {}});
      setProvincesList(response.data);
    } catch (err) {
      handleError(err);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={4} alignItems="flex-end">
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiHomeOutline} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="name"
                name="name"
                label="نام شرکت(برند تجاری)"
                inputRef={register({required: true})}
                error={errors.name && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiHomeOutline} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="companyName"
                name="companyName"
                label="نام حقیقی/حقوقی"
                inputRef={register({required: true})}
                error={errors.companyName && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiPhoneOutline}
                size={1}
                className={classes.icon}
                style={{transform: 'rotate(-90deg)'}}
              />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="phoneNumber"
                name="phoneNumber"
                label="شماره تماس"
                type="number"
                inputRef={register({required: true})}
                error={errors.phoneNumber && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiTextBoxSearchOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <FormControl style={{width: '100%'}}>
                <FormControl style={{width: '100%'}}>
                  <InputLabel id="work-field-lable">حوزه فعالیت</InputLabel>
                  <Select
                    native
                    fullWidth
                    name="workField"
                    labelId="work-field-lable"
                    id="work-field"
                    inputRef={register}
                    error={errors.workField && true}
                  >
                    {['ECOMMERCE','FMCG', 'INSTAGRAM'].map(
                      (field: any, index: number) => (
                        <option value={field} key={index}>
                          {field}
                        </option>
                      )
                    )}
                  </Select>
                </FormControl>
              </FormControl>
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiClipboardAccountOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <Controller
                name="province"
                control={control}
                defaultValue=""
                rules={{required: true}}
                render={({value}) => (
                  <Autocomplete
                    noOptionsText="موردی یافت نشد"
                    getOptionSelected={(option, value) =>
                      option.name === value?.name
                    }
                    getOptionLabel={option => option.name}
                    options={provincesList}
                    inputValue={value}
                    id="province"
                    onChange={(event: any, newValue: any) => {
                      setValue('customerCity', '');
                      getCities(newValue?.id);
                      setValue('province', newValue?.name);
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="استان"
                        onChange={e =>
                          setValue('province', e.target.value)
                        }
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                )}
              />
              <FormHelperText error focused>
                {errors?.province && 'استان سفاش‌دهنده الزامی میباشد'}
              </FormHelperText>
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiClipboardAccountOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <Controller
                name="city"
                control={control}
                defaultValue=""
                rules={{required: true}}
                render={({value}) => (
                  <Autocomplete
                    noOptionsText="موردی یافت نشد"
                    getOptionSelected={(option, value) =>
                      option.name === value?.name
                    }
                    getOptionLabel={option => option.name}
                    options={citiesList}
                    inputValue={value}
                    id="city"
                    onChange={(event: any, newValue: any) => {
                      setValue('city', newValue?.name);
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="شهر"
                        onChange={e =>
                          setValue('city', e.target.value)
                        }
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                )}
              />
              <FormHelperText error focused>
                {errors?.city && 'شهر سفاش‌دهنده الزامی میباشد'}
              </FormHelperText>
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiAccount} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="address"
                name="address"
                label="آدرس"
                inputRef={register({required: true})}
                error={errors.address && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiPostOutline} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="zipCode"
                name="zipCode"
                label="کدپستی شرکت"
                inputRef={register({
                  required: sendByCo,
                  pattern: /^\d{10}$/g,
                })}
                error={errors.zipCode && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiAccountOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="representative"
                name="representative"
                label="نماینده شرکت"
                inputRef={register({required: false})}
                error={errors.representative && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiClipboardAccountOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="representativePosition"
                name="representativePosition"
                label="سمت نماینده شرکت"
                inputRef={register({required: false})}
                error={errors.representativePosition && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiAccountNetworkOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="marketer"
                name="marketer"
                label="بازاریاب شرکت"
                inputRef={register({required: false})}
                error={errors.marketer && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiPostOutline} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="economicCode"
                name="economicCode"
                label="شناسه اقتصادی"
                inputRef={register({
                  required: false,
                })}
                error={errors.economicCode && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiCounter} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <FormControl style={{width: '100%'}}>
                <FormControl style={{width: '100%'}}>
                  <InputLabel id="ranking">{`رتبه‌بندی`}</InputLabel>
                  <Select
                    native
                    fullWidth
                    labelId="ranking"
                    id="rank"
                    name="ranking"
                    inputRef={register}
                    error={errors.ranking && true}
                  >
                    {['KEY_ACCOUNT', 'A', 'B'].map(
                      (rank: any, index: number) => (
                        <option value={rank} key={index}>
                          {rank}
                        </option>
                      )
                    )}
                  </Select>
                </FormControl>
              </FormControl>
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiAccountTieOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <Autocomplete
                open={openAutocomplete}
                onOpen={() => {
                  setOpenAutocomplete(true);
                }}
                onClose={() => {
                  setOpenAutocomplete(false);
                }}
                getOptionSelected={(option, value) =>
                  option.name === value.name
                }
                getOptionLabel={option => option.name}
                options={options}
                loading={loading}
                onChange={(event: any, newValue: any | null) => {
                  setAdminId(newValue?.id || null);
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="ادمین شرکت"
                    inputRef={register({required: false})}
                    name="admin"
                    id="admin"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {loading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiCounter} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <FormControl style={{width: '100%'}}>
                <FormControl style={{width: '100%'}}>
                  <InputLabel id="profile">{`پروفایل`}</InputLabel>
                  <Select
                    native
                    fullWidth
                    labelId="profile"
                    id="rank"
                    name="profile"
                    inputRef={register}
                    error={errors.profile && true}
                  >
                    {profiles?.map(
                      (profile: any, index: number) => (
                        <option value={profile.id} key={index}>
                          {profile.name}
                        </option>
                      )
                    )}
                  </Select>
                </FormControl>
              </FormControl>
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiPostOutline} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="sepidarCode"
                name="sepidarCode"
                label="کد سپیدار"
                inputRef={register({
                  required: false,
                })}
                error={errors.sepidarCode && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiPostOutline} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="registrationCode"
                name="registrationCode"
                label="شماره ثبت"
                inputRef={register({
                  required: false,
                })}
                error={errors.registrationCode && true}
              />
            </div>
          </div>
        </Grid>

        <Grid container item xs={12} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiAccountTieOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%', display: 'flex', alignItems: 'center'}}>
              <Checkbox
                checked={sendByCo}
                onChange={e => {
                  setSendByCo(e.target.checked);
                }}
                color="secondary"
                inputProps={{
                  'aria-label': 'secondary checkbox',
                }}
              />
              <div>
                <span>بسته با آدرس شرکت خودم ارسال شود</span>
              </div>
            </div>
          </div>
        </Grid>
        <Grid item container xs={8}>
          <Button
            fullWidth
            type="submit"
            size="large"
            data-cy="search"
            autoFocus
            variant="contained"
            color="secondary"
            disabled={
              Object.keys(flattenObject(removeEmptyValueObject({...watch()})))
                .length === 0
            }
          >
            {`ایجاد شرکت جدید`}
          </Button>
        </Grid>
        <Grid item container xs={4}>
          <Button
            fullWidth
            variant="contained"
            onClick={props.onClose}
            size="large"
            data-cy="search"
          >
            {`انصراف`}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
